const toString = Object.prototype.toString

export function is(val, type) {
  return toString.call(val) === `[object ${type}]`
}

/** ### 判断不是*undefined* */
export function isDef(val) {
  return typeof val !== 'undefined'
}

/** ### 判断传入参数是 *undefined* */
export function isUnDef(val) {
  return !isDef(val)
}

/** ### 判断是对象类型 */
export function isObject(val) {
  return val !== null && is(val, 'Object')
}

/**
 * ### 判断传入参数是空
 * - Array/String length等于0为空
 * - Map/Set size等于0为空
 * - Object 没有可枚举参数为空
 * - null/undefined 为空
 * - NaN 为空
 * @param val unknown
 * @returns boolean
 */
export function isEmpty(val) {
  if (isArray(val) || isString(val)) return val.length === 0

  if (val instanceof Map || val instanceof Set) return val.size === 0

  if (isObject(val)) return Object.keys(val).length === 0

  if (isNull(val) || isUnDef(val)) return true

  if (isNumber(val) && Number.isNaN(val)) return true

  return false
}

/** ### 是日期类型 */
export function isDate(val) {
  return is(val, 'Date')
}

/** ### 判断传入参数是 *null* */
export function isNull(val) {
  return val === null
}

/** ### 判断传入参数是 *null* 或者 *undefined* */
export function isNullOrUnDef(val) {
  return isUnDef(val) || isNull(val)
}

/** ### 判断传入参数是数字 */
export function isNumber(val) {
  return is(val, 'Number')
}

export const isStringNumber = (val) => {
  if (!isString(val)) return false
  return !Number.isNaN(Number(val))
}

/** ### 判断传入参数是 *promise* */
export function isPromise(val) {
  return is(val, 'Promise') && val instanceof Promise && [val.then, val.catch, val.finally].every(isFunction)
}

/** ### 判断传入参数是字符串 */
export function isString(val) {
  return is(val, 'String')
}

/** ### 判断传入参数是只包含数字的字符串 */
export function isNumberString(val) {
  return isString(val) && /^\d+$/.test(val)
}

/** ### 判断传入参数是方法 */
export function isFunction(val) {
  return typeof val === 'function'
}

/** ### 判断传入参数是布尔 */
export function isBoolean(val) {
  return is(val, 'Boolean')
}

/** ### 判断传入参数是正则对象 */
export function isRegExp(val) {
  return is(val, 'RegExp')
}

/** ### 判断传入参数是数组 */
export function isArray(val) {
  return val && Array.isArray(val)
}

/** ### 判断传入参数是html元素对象 */
export function isElement(o) {
  return (
    // @ts-ignore
    o !== null && typeof o === 'object' && o?.nodeType === 1 && o.nodeName && typeof o.nodeName === 'string'
  )
}

export function isHTMLDivElement(val) {
  return is(val, 'HTMLDivElement')
}

/** ### 判断传入参数是*map*对象 */
export function isMap(val) {
  return is(val, 'Map')
}

/** ### 判断传入参数是url链接 */
export function isUrl(path) {
  return /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)$/.test(
    path
  )
}

/** ### 判断传入参数是JOSN字符串 */
export function isJSONString() {
  if (!isString(val)) return false
  try {
    val = JSON.parse(val)
  } catch (error) {
    return false
  }
  return isArray(val) || isObject(val)
}

/** ### 判断是IE浏览器 */
export function isIE() {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

export function isBlob(val) {
  return is(val, 'Blob')
}
